import apiFetch from '../apiFetch'
export default function (token) {
  return apiFetch({ endPoint: 'laterUse', method: 'GET', body: null, token: token })
}
